export type JFilterExpr = '=' | '<>' | '>' | '<' | '>=' | '<=' | 'like' | 'in';

export interface JFilterCond {
  fld: string;
  expr: JFilterExpr;
  val: unknown;
}

export interface JFilterConnector {
  c: 'and' | 'or';
}

export type JFilterItem = JFilterCond | JFilterConnector;

class JFilterBuilder {
  private items: JFilterItem[] = [];

  add(fld: string, expr: JFilterExpr, val: unknown): this {
    this.items.push({ fld, expr, val });
    return this;
  }

  and(): this {
    this.items.push({ c: 'and' });
    return this;
  }

  or(): this {
    this.items.push({ c: 'or' });
    return this;
  }

  build(): JFilterItem[] {
    return this.items;
  }
}

export const jfilt = (): JFilterBuilder => new JFilterBuilder();
